import { METHOD } from '../method'

export const API_SEO = {
    DETAIL: {
        api: '/v1/dashboard-admin/main-page/home-page/seo',
        method: METHOD.GET,
    },
    UPDATE: {
        api: '/v1/dashboard-admin/main-page/home-page/seo',
        method: METHOD.PUT,
    },
}
